import React, { useState, useContext } from "react";

import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "../css/templateForm.scss";
import CircularProgressBar from "../utils/CircularProgressBar";
import ValueContext from "../utils/contextAPI/contextAPI";
import { setEdtailData } from "../utils";

export default function ExportTemplate({
  handleExportModal,
  closeExportModal,
  openExportModal,
  handleExport,
  exportFormats,
  cardData,
  setExportFormats,
}) {
  const appData = useContext(ValueContext);
  const [isloading, setIsloading] = useState(false);
  const handleExportFormat = (e) => {
    setExportFormats(e.target.value);
  };

  const sendCarddata = () => {
    for (let i = 0; i < cardData.length; i++) {
      appData.setDeckId(cardData[i]);
    }
  };
  const validateForm = () => {
    if (exportFormats === "mlrPdf" || exportFormats === "htmlveevaPackage") {
      return false;
    }
    return true;
  };

  return (
    <>
      {/* <Modal
        show={openExportModal}
        onHide={closeExportModal}
        className="template-export"
      >
        <Modal.Header className="template-forms-main2">
          {" "}
          <Modal.Title>
            {" "} */}
      <div className="template-export">
        <div className="template-forms-main2">
          <h6
            style={{
              margin: "0",
              fontFamily: "Nunito Sans",
              fontWeight: "bold",
              fontSize: "14px",
            }}
          >
            Export As
          </h6>
        </div>
        {/* </Modal.Title>
        </Modal.Header>
        <Modal.Body className="create-new-presentation"> */}
        {/* {isloading && (
            <CircularProgressBar
              isloading={isloading}
              setIsloading={setIsloading}
            />
          )} */}
        <div className="create-new-presentation">
          <h3 className="Select-format-text">Select format to be exported</h3>
          <div className="exportTemp">
            <div className="exportFormat">
              <input
                type="radio"
                value="mlrPdf"
                //   checked={exportFormats === "mlrPdf"}
                name="exportFormat"
                onChange={(e) => handleExportFormat(e)}
                style={{
                  height: "16px",
                  width: "16px",
                }}
                className="choose-export"
              />
              <label htmlFor="">
                MLR PDF
              </label>
            </div>
            <div className="exportFormat">
              <input
                type="radio"
                value="htmlveevaPackage"
                //value={exportFormats?.htmlveevaPackage}
                name="exportFormat"
                // checked={exportFormats === "htmlveevaPackage"}
                onChange={(e) => handleExportFormat(e)}
                //disabled="true"
                style={{
                  height: "16px",
                  width: "16px",
                }}
                className="choose-export"
              />
              <label htmlFor="">
                Veeva HTML package
              </label>
            </div>
          </div>
        </div>
        {/* </Modal.Body>

        <Modal.Footer className="modalActions"> */}
        <div className="export-modalActions">
          <div className="template-buttons2 d-flex">
            <Button
                className="btn cancel"
                type="button"
                // style={{ marginLeft: "15px" }}
                onClick={closeExportModal}
              >
                CANCEL
              </Button>
              <Button
                className="btn create-template-scratch exportButton"
                type="button"
                // style={{ height: "44px", marginRight: "-18px" }}
                onClick={(e) => {
                  //  sendCarddata();
                  handleExport();
                }}
                disabled={validateForm()}
              >
                EXPORT
              </Button>
            {/* <div className="col-md-3 d-grid gap-2 d-md-flex justify-content-md-start">
              
            </div> */}
            {/* <div className=" col-md-9 d-grid gap-2 d-md-flex justify-content-md-end create-template-button">
              
            </div> */}
          </div>
        </div>
      </div>
      {/* </Modal.Footer>
      </Modal> */}
    </>
  );
}
